import getNative from './_getNative';

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

export default nativeCreate;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_nativeCreate.js
// module id = 87
// module chunks = 0